import { c as _c } from "react/compiler-runtime";
import Text from '../base/Text';
import { Div } from '../helpers/StyledUtils';
const MetricNoData: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Div><Text neutral={true} semi={true}>No data to display.</Text></Div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default MetricNoData;